"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeFooterOffsetRibbonCommand = exports.ChangeFooterOffsetCommand = void 0;
var tslib_1 = require("tslib");
var section_property_descriptor_1 = require("../../../core/model/section/section-property-descriptor");
var change_section_properties_command_base_1 = require("./change-section-properties-command-base");
var ChangeFooterOffsetCommand = (function (_super) {
    tslib_1.__extends(ChangeFooterOffsetCommand, _super);
    function ChangeFooterOffsetCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChangeFooterOffsetCommand.prototype.getDescriptor = function () {
        return section_property_descriptor_1.SectionPropertyDescriptor.footerOffset;
    };
    return ChangeFooterOffsetCommand;
}(change_section_properties_command_base_1.ChangeSectionPropertiesCommandBase));
exports.ChangeFooterOffsetCommand = ChangeFooterOffsetCommand;
var ChangeFooterOffsetRibbonCommand = (function (_super) {
    tslib_1.__extends(ChangeFooterOffsetRibbonCommand, _super);
    function ChangeFooterOffsetRibbonCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChangeFooterOffsetRibbonCommand.prototype.DEPRECATEDConvertOptionsParameter = function (parameter) {
        return this.control.uiUnitConverter.UIToTwips(parameter);
    };
    ChangeFooterOffsetRibbonCommand.prototype.getStateValue = function (options) {
        if (options === void 0) { options = this.convertToCommandOptions(null); }
        return this.control.uiUnitConverter.twipsToUI(_super.prototype.getStateValue.call(this, options));
    };
    ChangeFooterOffsetRibbonCommand.prototype.isEnabled = function (options) {
        return _super.prototype.isEnabled.call(this, options) &&
            this.control.innerClientProperties.viewsSettings.isPrintLayoutView &&
            this.selection.activeSubDocument.isHeaderFooter();
    };
    return ChangeFooterOffsetRibbonCommand;
}(ChangeFooterOffsetCommand));
exports.ChangeFooterOffsetRibbonCommand = ChangeFooterOffsetRibbonCommand;
